import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import { trackServiceInquiry } from '../lib/analytics';
import { usePrefersReducedMotion } from '../lib/usePrefersReducedMotion';
import TrackVisibility from 'react-on-screen';
import 'animate.css';

const CALENDLY_URL = 'https://calendly.com/george-hoffmann-whiskeyrebel/discovery-call-30-minutes';
const EMAIL = 'george.hoffmann@whiskeyrebel.design';
const PHONE = '717-779-6026';

export const FinalCTASection = () => {
  const prefersReducedMotion = usePrefersReducedMotion();

  const handleClick = () => {
    trackServiceInquiry('final_cta_strategy_session');
  };

  return (
    <section className="final-cta" id="final-cta" aria-labelledby="final-cta-heading">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={9}>
            <TrackVisibility once>
              {({ isVisible }) => (
                <div className={`final-cta-panel ${prefersReducedMotion ? "" : (isVisible ? "animate__animated animate__fadeIn" : "pre-reveal")}`}>
                  <h2 id="final-cta-heading">Let's build something real.</h2>
                  <p className="final-cta-subhead">
                    No pitch. No pressure. 30 minutes to find out exactly what your digital presence is costing you — and what it looks like to fix it.
                  </p>

                  <a
                    href={CALENDLY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleClick}
                    className="btn-final-cta"
                  >
                    Book Your Strategy Session <ArrowRightCircle size={22} aria-hidden="true" />
                    <span className="visually-hidden"> (opens in new tab)</span>
                  </a>

                  <p className="final-cta-direct">
                    Or reach out direct:{' '}
                    <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
                    <span aria-hidden="true"> · </span>
                    <a href={`tel:${PHONE.replace(/-/g, '')}`}>{PHONE}</a>
                  </p>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
